export default __webpack_public_path__ + "static/media/overseas_ko.d27ad5e9.csv";